import React from 'react';
import { Navigate } from 'react-router-dom';
import { canAccess } from '../utils/adminRole';
import { AdminStorage } from '../utils/storage';

/**
 * ProtectedRoute Component
 * Protects admin routes based on role permissions
 * Redirects unauthorized users to dashboard
 */
export default function ProtectedRoute({ children, resource }) {
  // Admin auth now lives in an httpOnly cookie; this checks the cached
  // profile written at login (sessionStorage, auto-clears on tab close).
  if (!AdminStorage.isLoggedIn()) {
    return <Navigate to="/admin/login" replace />;
  }
  
  // Check if user has access to this resource
  if (resource && !canAccess(resource)) {
    // User doesn't have permission - redirect to dashboard
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  // User has permission - render the protected component
  return children;
}
